export const statuses = {
  WAITING: 'waiting',
  UPLOADING: 'uploading',
  CANCELING: 'canceling',
  CANCELED: 'canceled',
  FINISHED: 'finished',
  GENERATING_PREVIEW: 'preview',
};

export const acceptedFormats = {
  // Images
  'image/*': [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.bmp',
    '.svg',
    '.tif',
    '.tiff',
    '.webp',
  ],

  // Audio
  'audio/aac': ['.aac'],

  // Documents
  'application/x-abiword': ['.abw'],
  'application/x-freearc': ['.arc'],
  'application/vnd.amazon.ebook': ['.azw'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'text/csv': ['.csv'],
  'application/rtf': ['.rtf'],
  'application/pdf': ['.pdf'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    '.pptx',
  ],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'text/plain': ['.txt'],
  'text/html': ['.htm', '.html'],
  'application/javascript': ['.js', '.mjs'],
  'application/json': ['.json', '.jsonld'],
  'application/xhtml+xml': ['.xhtml'],
  'application/xml': ['.xml'],

  // Fonts
  'application/x-font-ttf': ['.ttf'],
  'application/font-woff': ['.woff'],
  'application/font-woff2': ['.woff2'],
  'application/vnd.ms-fontobject': ['.eot'],
  'font/otf': ['.otf'],

  // Archives
  'application/x-7z-compressed': ['.7z'],
  'application/zip': ['.zip'],
  'application/x-rar-compressed': ['.rar'],
  'application/x-tar': ['.tar'],
  'application/gzip': ['.gz'],

  // Executables / scripts
  'application/x-sh': ['.sh'],
  'application/octet-stream': ['.bin', '.jar', '.mpkg'],

  // Calendar
  'text/calendar': ['.ics'],

  // Misc / less common
  'application/x-shockwave-flash': ['.swf'],
  'application/ogg': ['.ogx'],
  'application/vnd.visio': ['.vsd'],
  'application/vnd.mozilla.xul+xml': ['.xul'],
  'text/css': ['.css'],

  // Video
  'video/*': [],
};

export const acceptedImageFormats = {
  'image/*': ['.gif', '.webp', '.png', '.jpeg', '.bmp', '.jpg', '.svg'],
};

export const customDragAndDropAccetedFormats = [
  'image/*',
  '.gif',
  '.webp',
  '.png',
  '.jpeg',
  '.bmp',
  '.jpg',
  '.svg',
];

export type ExtendedFile = {
  name: string;
  sizeText: string;
  size: number;
  currentUpload: number;
  status: string;
  progress: number;
  type?: string;
};
